import styles from "./Input.module.scss";
export default function Input({ label, placeholder, id, required = false, ...rest }) {
  return (
    <div className={styles.wrapper}>
      <input id={id} placeholder={placeholder} required={required} {...rest} />
      <label htmlFor={id}>{label ?? placeholder ?? ""}</label>
    </div>
  );
}
